import { encryptAES, decryptAES } from "../utils/cryptoUtils";
import type CryptoJS from "crypto-js";
export class EncryptionService {
  constructor(private readonly key: CryptoJS.lib.WordArray) {}
  encrypt(s:  string) {return encryptAES(s,this.key);}  decrypt(o:  {iv: string; ct: string; mac: string}) {return decryptAES(o,this.key);} }
